import React, { useRef, useState, useEffect } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classNames from "classnames";

import CartItem from "../cart-item/CartItemController.jsx";
import OrderingInfo from "../cart-item/OrderingInfo.jsx";
import "./styles.styl";

export default function CartItemList(props) {
  const {
    delivery,
    delivery_smartfill_state,
    delivery_suggestion_state,
    days_until_ordering_window_opens,
    allow_ordering_before_suggestions_at,
    remaining_time,
    editable,
    onChange,
    onRemove,
    stickyPaymentContainerHeight,
    cartRowHeight,
    cardHeaderHeight,
  } = props;
  const [openedId, setOpenedId] = useState(null);
  const [isSticky, setIsSticky] = useState(true);
  const [dynamicHeight, setDynamicHeight] = useState("auto");

  const cartItemListRef = useRef(null);
  const cssTransitionListRef = useRef(null);
  const [openCartItemId, setOpenCartItemId] = useState(null);
  const { orders } = delivery; // when choosing from catalog its a deliverlisting, when adapting in cart its a deliverorder...
  const items = orders;
  const empty = items.length === 0;
  const isDesktop = window.innerWidth > 940;

  function handleClick(paramOpenedId) {
    setOpenedId(paramOpenedId);
  }

  function setEditVisible(productId) {
    openCartItemId == productId
      ? setOpenCartItemId(null)
      : setOpenCartItemId(productId);
  }

  useEffect(() => {
    const calculateHeight = () => {
      if (cartRowHeight && stickyPaymentContainerHeight) {
        const height =
          cartRowHeight - (stickyPaymentContainerHeight + cardHeaderHeight);
        setDynamicHeight(`${height}px`);
      }
    };

    calculateHeight();
  }, [stickyPaymentContainerHeight, cartRowHeight]);

  return (
    <div
      className={classNames("cart-item-list", {
        sticky: isDesktop && isSticky,
      })}
      style={{
        maxHeight: dynamicHeight,
        overflow: "auto",
      }}
      ref={cartItemListRef}
    >
      <OrderingInfo
        delivery={delivery}
        editable={editable}
        allow_ordering_before_suggestions_at={
          allow_ordering_before_suggestions_at
        }
        delivery_smartfill_state={delivery_smartfill_state}
        delivery_suggestion_state={delivery_suggestion_state}
        days_until_ordering_window_opens={days_until_ordering_window_opens}
        empty={empty}
        remaining_time={remaining_time}
        companyEmail={props.companyEmail}
        nextEditableCart={props.nextEditableCart}
      />
      <div ref={cssTransitionListRef}>
        <TransitionGroup className="cart-item-list__items">
          {items.map((item, index) => (
            <CSSTransition classNames="fade" timeout={400} key={item.id}>
              <CartItem
                editable={delivery.editable}
                onChange={onChange}
                onRemove={onRemove}
                item={item}
                handleClick={handleClick}
                openedId={openedId}
                delivery={delivery}
                setEditVisible={setEditVisible}
                openCartItemId={openCartItemId}
                isItemOpen={openCartItemId == item.id}
                isFavourite={item.is_favourite}
                cartItemListRef={cartItemListRef}
                index={index}
              />
            </CSSTransition>
          ))}
        </TransitionGroup>
      </div>
    </div>
  );
}
